import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  title?: string;
  children: React.ReactNode;
  className?: string;
  accentColor?: string;
  hoverable?: boolean;
  style?: React.CSSProperties;
}

export const Card = ({
  title,
  children,
  className = '',
  accentColor,
  hoverable = false,
  style,
  ...rest
}: CardProps) => {
  const [hovered, setHovered] = React.useState(false);

  const baseStyle: React.CSSProperties = {
    backgroundColor: 'white',
    borderLeft: accentColor ? `4px solid ${accentColor}` : undefined,
    boxShadow:
      hovered && hoverable ? '0 4px 16px -4px rgba(0,26,112,0.10)' : '0 1px 4px rgba(0,0,0,0.04)',
    transform: hovered && hoverable ? 'translateY(-2px)' : 'translateY(0)',
    transition: 'box-shadow 0.3s, transform 0.3s',
    ...style,
  };

  return (
    <section
      className={`rounded-[2rem] p-6 border border-gray-100 cursor-default ${className}`}
      style={baseStyle}
      onMouseEnter={hoverable ? () => setHovered(true) : undefined}
      onMouseLeave={hoverable ? () => setHovered(false) : undefined}
      {...rest}
    >
      {title && <h2 className="text-lg font-semibold text-klon-primary-dark mb-4">{title}</h2>}
      {children}
    </section>
  );
};
